// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';
import { ProjectFinalizationInfoVO } from './project.vo';

@JsonObject('ProjectFinalizationInfoDTO')
export class ProjectFinalizationInfoDTO {

  @JsonProperty('reportId', 'string')
  public reportId: string;
  @JsonProperty('projectId', 'Number')
  public projectId: number;
  @JsonProperty('projectVersion', 'Number')
  public projectVersion: number;
  @JsonProperty('projectFinalizationInfoVO', 'ProjectFinalizationInfoVO')
  public projectFinalizationInfoVO: ProjectFinalizationInfoVO;
  @JsonProperty('jsonInfoString', 'String')
  public jsonInfoString: string;
}
